import { type AnyAction } from 'redux';
import { FETCH_TOPOLOGY_SUCCESS } from './topology-actions';

type State = Record<string, any>;

export default function topology(state: State = {}, action: AnyAction): State {
  switch (action.type) {
    case FETCH_TOPOLOGY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
